<div class="reassignmentPage bpr_section-page">
  <h3 class="bpr_section-title">
    {{'asm.order.reassignment.header'|translate}} {{order}}
  </h3>
  <header class="reassignmentPage_header">
    <fieldset>
      <div class="engi-radio-wrapper">
        <input type="radio" name="" id="client" [value]="reassigmentType.client" [(ngModel)]="accountType" (change)="changeType(reassigmentType.client)">
        <label for="client">{{'asm.order.reassignment.client' | translate}}</label>
      </div>
      <div class="engi-radio-wrapper" *ngIf="technicalId !== ''">
        <input type="radio" name="" id="technical" [value]="reassigmentType.technical" [(ngModel)]="accountType" (change)="changeType(reassigmentType.technical)">
        <label for="technical">{{'asm.order.reassignment.technical' | translate}}</label>
      </div>
    </fieldset>
    <v-asm-customer-search-form
      #searchInput
      [inputValue]="selectedCustomerLabel"
      (keyupEvent)="inputUpdateDetected($event)"
      [labelText]="'asm.order.reassignment.label'"
      [processing]="searching"
      *ngIf="accountType === 'client'"
    >
    </v-asm-customer-search-form>
    <p *ngIf="accountType === 'technical'">
      {{'asm.order.reassignment.technical.desc'|translate}} <b>{{technicalId}}</b>
    </p>
  </header>

  <div *ngIf="(customersObs | async) as customers" class="a-reference-point">
    <v-asm-customers-for-order *ngIf="showSearchResult" (customerSelectedEvent)="selectCustomerDetected($event)" [customers]="customers"></v-asm-customers-for-order>
  </div>

  <footer class="reassignmentPage_footer">
    <button type="submit" class="reassignmentPage_submitButton" [disabled]="newCustomerId.value === ''">{{'asm.order.reassignment.submit'|translate}}</button>
    <a [href]="backLink" class="reassignmentPage_cancelButton">{{'asm.order.reassignment.back'|translate}}</a>
  </footer>
</div>
